import type {} from '@angular/localize/init';

export const rgTakeBreakCustomSelfExclusionMessageFn: () => string = () =>
  $localize`If you want to exclude yourself for more than 3 months, please contact customer service.`;
